import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPinIcon, CreditCardIcon, ChevronDownIcon, EditIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { useCart } from '../context/CartContext';
import { useOrder } from '../context/OrderContext';
const Checkout: React.FC = () => {
  const navigate = useNavigate();
  const {
    items,
    subtotal
  } = useCart();
  const {
    createOrder
  } = useOrder();
  const [addressFormVisible, setAddressFormVisible] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('credit-card');
  const [promoCode, setPromoCode] = useState('');
  const [isApplyingPromo, setIsApplyingPromo] = useState(false);
  // Mock address data
  const address = {
    type: 'Work',
    line1: '1A Pioneer Sector Walk, #02-22',
    postalCode: '627828',
    remarks: 'Enter from the side door'
  };
  // Mock fees and discounts
  const deliveryFee = 2.5;
  const tax = subtotal * 0.07;
  const discount = 0;
  const total = subtotal + deliveryFee + tax - discount;
  const handleApplyPromo = () => {
    setIsApplyingPromo(true);
    setTimeout(() => {
      setIsApplyingPromo(false);
      // Handle promo code logic here
    }, 1000);
  };
  const handlePlaceOrder = async () => {
    try {
      const orderId = await createOrder(paymentMethod);
      navigate(`/order/confirmation/${orderId}`);
    } catch (error) {
      console.error('Failed to create order:', error);
    }
  };
  return <div className="max-w-4xl mx-auto" data-id="element-329">
      <h1 className="text-2xl font-bold mb-6" data-id="element-330">Checkout</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-331">
        <div className="md:col-span-2 space-y-6" data-id="element-332">
          {/* Delivery address */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-333">
            <div className="p-4 border-b border-gray-200" data-id="element-334">
              <h2 className="font-semibold flex items-center" data-id="element-335">
                <MapPinIcon size={18} className="mr-2 text-[#E84118]" data-id="element-336" />
                Delivery Address
              </h2>
            </div>
            {addressFormVisible ? <div className="p-4" data-id="element-337">
                <Input label="Address Line 1" placeholder="Street address, building name" value={address.line1} required data-id="element-338" />
                <Input label="Postal Code" placeholder="Enter postal code" value={address.postalCode} required data-id="element-339" />
                <Input label="Address Remarks" placeholder="Additional information for the delivery person" value={address.remarks} data-id="element-340" />
                <div className="flex justify-end space-x-3 mt-4" data-id="element-341">
                  <Button variant="outline" onClick={() => setAddressFormVisible(false)} data-id="element-342">
                    Cancel
                  </Button>
                  <Button onClick={() => setAddressFormVisible(false)} data-id="element-343">
                    Save Address
                  </Button>
                </div>
              </div> : <div className="p-4" data-id="element-344">
                <div className="flex justify-between items-start" data-id="element-345">
                  <div data-id="element-346">
                    <div className="flex items-center" data-id="element-347">
                      <span className="font-medium mr-2" data-id="element-348">{address.type}</span>
                      <span className="text-sm text-gray-600" data-id="element-349">
                        {address.postalCode}
                      </span>
                    </div>
                    <p className="text-gray-700 mt-1" data-id="element-350">{address.line1}</p>
                    {address.remarks && <p className="text-sm text-gray-600 mt-1" data-id="element-351">
                        <span className="font-medium" data-id="element-352">Remarks:</span>{' '}
                        {address.remarks}
                      </p>}
                  </div>
                  <button onClick={() => setAddressFormVisible(true)} className="text-[#E84118] flex items-center text-sm" data-id="element-353">
                    <EditIcon size={14} className="mr-1" data-id="element-354" />
                    Edit
                  </button>
                </div>
                <div className="mt-4 flex justify-end" data-id="element-355">
                  <button className="text-[#E84118] text-sm" onClick={() => {}} data-id="element-356">
                    Change Address
                  </button>
                </div>
              </div>}
          </div>
          {/* Payment method */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-357">
            <div className="p-4 border-b border-gray-200" data-id="element-358">
              <h2 className="font-semibold flex items-center" data-id="element-359">
                <CreditCardIcon size={18} className="mr-2 text-[#E84118]" data-id="element-360" />
                Payment Method
              </h2>
            </div>
            <div className="p-4" data-id="element-361">
              <div className="space-y-3" data-id="element-362">
                <label className="flex items-center p-3 border rounded-md cursor-pointer bg-gray-50" data-id="element-363">
                  <input type="radio" name="paymentMethod" value="credit-card" checked={paymentMethod === 'credit-card'} onChange={() => setPaymentMethod('credit-card')} className="h-4 w-4 text-[#E84118] focus:ring-[#E84118]" data-id="element-364" />
                  <span className="ml-2" data-id="element-365">Credit / Debit Card</span>
                </label>
                <label className="flex items-center p-3 border rounded-md cursor-pointer" data-id="element-366">
                  <input type="radio" name="paymentMethod" value="paynow" checked={paymentMethod === 'paynow'} onChange={() => setPaymentMethod('paynow')} className="h-4 w-4 text-[#E84118] focus:ring-[#E84118]" data-id="element-367" />
                  <span className="ml-2" data-id="element-368">PayNow</span>
                </label>
                <label className="flex items-center p-3 border rounded-md cursor-pointer" data-id="element-369">
                  <input type="radio" name="paymentMethod" value="cash" checked={paymentMethod === 'cash'} onChange={() => setPaymentMethod('cash')} className="h-4 w-4 text-[#E84118] focus:ring-[#E84118]" data-id="element-370" />
                  <span className="ml-2" data-id="element-371">Cash on Delivery</span>
                </label>
              </div>
              {paymentMethod === 'credit-card' && <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-372">
                  <Input label="Card Number" placeholder="1234 5678 9012 3456" required data-id="element-373" />
                  <div className="grid grid-cols-2 gap-4" data-id="element-374">
                    <Input label="Expiry Date" placeholder="MM/YY" required data-id="element-375" />
                    <Input label="CVV" placeholder="123" required data-id="element-376" />
                  </div>
                  <Input label="Name on Card" placeholder="John Smith" required data-id="element-377" />
                </div>}
            </div>
          </div>
          {/* Promo code */}
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-378">
            <div className="p-4" data-id="element-379">
              <h2 className="font-semibold mb-3" data-id="element-380">Promo Code / Gift Card</h2>
              <div className="flex" data-id="element-381">
                <input type="text" placeholder="Enter code" value={promoCode} onChange={e => setPromoCode(e.target.value)} className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-382" />
                <Button onClick={handleApplyPromo} disabled={!promoCode.trim() || isApplyingPromo} className="rounded-l-none" data-id="element-383">
                  {isApplyingPromo ? 'Applying...' : 'Apply'}
                </Button>
              </div>
            </div>
          </div>
        </div>
        {/* Order summary */}
        <div className="md:col-span-1" data-id="element-384">
          <div className="bg-white rounded-lg shadow-md overflow-hidden sticky top-6" data-id="element-385">
            <div className="p-4 border-b border-gray-200" data-id="element-386">
              <h2 className="font-semibold" data-id="element-387">Order Summary</h2>
            </div>
            <div className="p-4" data-id="element-388">
              <div className="flex justify-between items-center mb-2" data-id="element-389">
                <span className="text-gray-600" data-id="element-390">{items.length} items</span>
                <button className="text-[#E84118] text-sm flex items-center" data-id="element-391">
                  View Details
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-392" />
                </button>
              </div>
              <div className="space-y-2 mt-4" data-id="element-393">
                <div className="flex justify-between" data-id="element-394">
                  <span className="text-gray-600" data-id="element-395">Subtotal</span>
                  <span data-id="element-396">${subtotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between" data-id="element-397">
                  <span className="text-gray-600" data-id="element-398">Delivery Fee</span>
                  <span data-id="element-399">${deliveryFee.toFixed(2)}</span>
                </div>
                <div className="flex justify-between" data-id="element-400">
                  <span className="text-gray-600" data-id="element-401">Tax</span>
                  <span data-id="element-402">${tax.toFixed(2)}</span>
                </div>
                {discount > 0 && <div className="flex justify-between text-green-600" data-id="element-403">
                    <span data-id="element-404">Discount</span>
                    <span data-id="element-405">-${discount.toFixed(2)}</span>
                  </div>}
                <div className="border-t border-gray-200 pt-2 mt-2 flex justify-between font-bold" data-id="element-406">
                  <span data-id="element-407">Total</span>
                  <span data-id="element-408">${total.toFixed(2)}</span>
                </div>
              </div>
              <Button onClick={handlePlaceOrder} fullWidth size="lg" className="mt-6" data-id="element-409">
                Place Order
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Checkout;